import Icon from 'veui/components/Icon'

Icon.register({
  'text-bullets': {
    paths: [
      {
        d: 'M672 190H256a32 32 0 010-64h416a32 32 0 010 64zm-560-80a48 48 0 1048 48 48 48 0 00-48-48zm592 274a32 32 0 00-32-32H256a32 32 0 000 64h416a32 32 0 0032-32zm0 223a32 32 0 00-32-32H256a32 32 0 000 64h416a32 32 0 0032-32zM112 336a48 48 0 1048 48 48 48 0 00-48-48zm0 223a48 48 0 1048 48 48 48 0 00-48-48z'
      }
    ],
    width: '768',
    height: '768'
  }
})
